const defaults = {
  nbTiles: 100,
  supersampling: true,
};

const debug = {
  // nbTiles: 100,
  // supersampling: false,
};

export const param = { ...defaults, ...debug };
